export const images = [
    
    {
        src: "assets/gallery/Avoca1.jpg",
        original:  "assets/gallery/Avoca1.jpg",
   
    },
    {
        src: "assets/gallery/countertop.jpg",
        original:  "assets/gallery/countertop.jpg",
   
    },
    {
        src: "assets/gallery/Donerail1.jpg",
        original:  "assets/gallery/Donerail1.jpg",
   
    },
    {
        src: "assets/gallery/Donerail2.jpg",
        original:  "assets/gallery/Donerail2.jpg",
   
    },
    {
        src: "assets/gallery/highview1.jpg",
        original:  "assets/gallery/highview1.jpg",
   
    },
    {
        src: "assets/gallery/highview2.jpg",
        original:  "assets/gallery/highview2.jpg",
   
    },
    {
        src: "assets/gallery/Ledgestone1.jpg",
        original:  "assets/gallery/Ledgestone1.jpg",
   
    },
    {
        src: "assets/gallery/Legacy1.jpg",
        original:  "assets/gallery/Legacy1.jpg",
   
    },
    {
        src: "assets/gallery/outdoor.jpg",
        original:  "assets/gallery/outdoor.jpg",
   
    }


];